export default "__VITE_ASSET__CtTVKgVR__"